import { useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 10) { setError('La contraseña debe tener al menos 10 caracteres.'); return; }
    if (password !== confirm) { setError('Las contraseñas no coinciden.'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json() as { ok?: boolean; error?: string };
      if (!res.ok || !data.ok) {
        setError(data.error === 'invalid_or_expired' ? 'El enlace ha caducado o no es válido. Solicita uno nuevo.' : 'No se pudo restablecer. Inténtalo de nuevo.');
        setLoading(false);
        return;
      }
      navigate('/login', { replace: true });
    } catch {
      setError('Error de conexión.');
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#0f172a' }}>
        <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center">
          <p className="text-slate-600 mb-4">Enlace de restablecimiento no válido.</p>
          <Link to="/forgot-password" className="text-sm text-teal-600 hover:text-teal-700 font-medium">Solicitar uno nuevo</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#0f172a' }}>
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
        <h1 className="text-xl font-bold text-slate-900 mb-2">Nueva contraseña</h1>
        <p className="text-sm text-slate-600 mb-5">Elige una contraseña segura (mínimo 10 caracteres).</p>
        {error && <div className="mb-4 p-3 rounded-lg bg-rose-50 text-rose-700 text-sm border border-rose-200">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="password" required value={password} onChange={e => setPassword(e.target.value)} placeholder="Nueva contraseña"
            className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 text-sm" />
          <input type="password" required value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repite la contraseña"
            className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 text-sm" />
          <button type="submit" disabled={loading}
            className="w-full py-2.5 bg-teal-700 hover:bg-teal-800 disabled:bg-teal-400 text-white rounded-lg font-medium text-sm transition-colors">
            {loading ? 'Guardando...' : 'Guardar contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}
